import { useQuery } from "@apollo/client/react";

import { RunContext } from "components/Run/Context";
import {
  GET_MODULE_LOGS_DOWNLOAD_URL,
  GET_STACK_LOGS_DOWNLOAD_URL,
} from "shared/Run/useDownloadLogs/gql";
import { getLogsDownloadUrl } from "shared/Run/useDownloadLogs/helpers";
import useTypedContext from "hooks/useTypedContext";
import { isModuleRunType } from "utils/run";

type UseRunLogsDeletedOptions = {
  skip?: boolean;
};

// Deletion is run-wide and logs expire in write order, so the newest log-bearing phase answers for the whole run.
const useRunLogsDeleted = ({ skip }: UseRunLogsDeletedOptions = {}) => {
  const { run, stack } = useTypedContext(RunContext);

  const isModuleRun = isModuleRunType(run.type);
  const phase = run.history.findLast(({ hasLogs }) => hasLogs);

  const { data, loading } = useQuery(
    isModuleRun ? GET_MODULE_LOGS_DOWNLOAD_URL : GET_STACK_LOGS_DOWNLOAD_URL,
    {
      variables: {
        [isModuleRun ? "moduleId" : "stackId"]: stack.id,
        runId: run.id,
        state: phase?.state,
        ...(isModuleRun ? {} : { stateVersion: phase?.stateVersion }),
      },
      skip: skip || !phase,
      fetchPolicy: "network-only",
    }
  );

  const logs = getLogsDownloadUrl(data);

  return {
    logsDeleted: !!logs?.deleted,
    logsExpired: !!logs?.expired,
    loading,
  };
};

export default useRunLogsDeleted;
